import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { connect } from 'react-redux';
import Link from 'react-router/lib/Link';
import { withRouter } from 'react-router';
import { lifecycle, withState, compose, withHandlers } from 'recompose';
import { t } from '../../../../modules/infra/i18n';

import * as shapes from './shapes';
import List from './components/List';
import * as actions from './actions';
import { getActiveBrandId } from '../../../auth/selectors';
import withTimezone from '../../../auth/utils/withTimezone';
import Filters from '../../reports/filters/components/Filters';
import withPermissions from '../../../auth/utils/withPermissions';
import { canUserModifyPromos } from '../../../common/helpers/users';
import withActiveUserIdAndType from '../../../common/hoc/withActiveUserIdAndType';

const PromoCodes = (props) => (
  <div className="u-max-width-1050 u-margin-auto u-mv-">
    <div className="c-wrapper s-v2 u-pb0">
      <div className="layout">
        <div className="layout__item u-5/6-extralarge-and-up">
          <Filters
            onDateChange={props.onDateChange}
            disableBarberFilter
            applyFilter={props.fetchData}
            csvJobName="promo-codes-report"
            csvModalTitle={t('settings:promo_codes.export_modal_title')}
            startDate={props.startDate}
            endDate={props.endDate}
            filters={{ startDate: props.startDate, endDate: props.endDate }}
            queueDateOnly
          />
        </div>
        <div className="layout__item u-1/6-extralarge-and-up" display-if={canUserModifyPromos(props.permissions)}>
          <Link className="c-btn c-btn--medium" to={`${props.baseUrl}/add`}>
            {t('settings:promo_codes.add_promo_code')}
          </Link>
        </div>
      </div>
    </div>
    <List promoCodes={props.promoCodes} baseUrl={props.baseUrl} canModify={canUserModifyPromos(props.permissions)} />
  </div>
);

PromoCodes.propTypes = {
  promoCodes: shapes.promoCodes.isRequired,
  fetchData: shapes.handler.isRequired,
  baseUrl: shapes.url.isRequired,
  permissions: PropTypes.object.isRequired,
  onDateChange: shapes.handler.isRequired,
  startDate: PropTypes.instanceOf(Date).isRequired,
  endDate: PropTypes.instanceOf(Date).isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  shop: state.auth.shop,
  barberUser: state.auth.barberUser,
  activeBrandId: getActiveBrandId(state),
  promoCodes: state.settings.promoCodes,
  baseUrl: ownProps.location.pathname,
});

const mapDispatchToProps = {
  fetchOwnerPromoCodes: actions.fetchOwnerPromoCodes,
};

export default compose(
  withActiveUserIdAndType(),
  withPermissions,
  withRouter,
  withTimezone,
  connect(mapStateToProps, mapDispatchToProps),
  withState('startDate', 'setStartDate', (props) => moment().tz(props.timezone).subtract(6, 'days').toDate()),
  withState('endDate', 'setEndDate', (props) => moment.tz(props.timezone).toDate()),
  withHandlers({
    fetchData: (props) => () => {
      const { activeId, activeType, startDate, endDate, timezone } = props;
      return props.fetchOwnerPromoCodes(activeId, activeType, startDate, endDate, timezone);
    },
    onDateChange: (props) => (from, to) => {
      props.setStartDate(from);
      props.setEndDate(to);
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.fetchData();
    },
  })
)(PromoCodes);
